import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { IbusinessDefaultBannerComponent } from '@kuiper/icons';
import { RouterLink } from '@angular/router';
import { Workspace } from '../../models/workspace.model';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'lib-navbar-banner-logo',
  imports: [IbusinessDefaultBannerComponent, RouterLink, TranslocoPipe],
  templateUrl: './navbar-banner-logo.component.html',
  styleUrl: './navbar-banner-logo.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavbarBannerLogoComponent {
  isCentral = input<boolean>(false);
  selectedWorkspace = input<Workspace | null>(null);
  projectName = input<string | null>(null);
}
